import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import AdminLayout from './components/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import CreateCertificate from './pages/CreateCertificate';
import CreateLetter from './pages/CreateLetter';
import ManageDocuments from './pages/ManageDocuments';
import VerifyCertificate from './pages/VerifyCertificate';
import VerifyLetter from './pages/VerifyLetter';
import Verify from './pages/Verify';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Public Routes with Main Website Header */}
          <Route path="/" element={
            <div className="App">
              <Header />
              <main><Home /></main>
              <Footer />
            </div>
          } />
          <Route path="/about" element={
            <div className="App">
              <Header />
              <main><About /></main>
              <Footer />
            </div>
          } />
          <Route path="/services" element={
            <div className="App">
              <Header />
              <main><Services /></main>
              <Footer />
            </div>
          } />
          <Route path="/projects" element={
            <div className="App">
              <Header />
              <main><Projects /></main>
              <Footer />
            </div>
          } />
          <Route path="/contact" element={
            <div className="App">
              <Header />
              <main><Contact /></main>
              <Footer />
            </div>
          } />

          {/* Public Verification Routes (No Header/Footer) - Unified verification for all document types */}
          <Route path="/verify" element={<Verify />} />
          <Route path="/verify-letter" element={<Verify />} />
          <Route path="/verify-certificate" element={<Verify />} />

          {/* Admin Login Route (No Header/Footer) */}
          <Route path="/dashboard/login" element={<AdminLogin />} />

          {/* Protected Admin Routes with Admin Header */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <AdminLayout>
                <AdminDashboard />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/dashboard/create-certificate" element={
            <ProtectedRoute>
              <AdminLayout>
                <CreateCertificate />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/dashboard/create-letter" element={
            <ProtectedRoute>
              <AdminLayout>
                <CreateLetter />
              </AdminLayout>
            </ProtectedRoute>
          } />

          <Route path="/dashboard/manage-documents" element={
            <ProtectedRoute>
              <AdminLayout>
                <ManageDocuments />
              </AdminLayout>
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
